import { useEffect } from 'react';

export interface FoucWrapperProps {
  children: React.ReactNode;
}

/**
 * Hides content until the first client render to avoid a flash of unstyled
 * content on initial load.
 *
 * This lived in app/template.tsx, and templates remount on every navigation by
 * design — so it replayed the reveal each time and flashed the page on route
 * changes. Only the first load needs it, so it belongs in the layout, which
 * mounts once.
 */
const FoucWrapper: React.FC<FoucWrapperProps> = ({ children }) => {
  useEffect(() => {
    const foucWrapper = window.document.getElementById('fouc-wrapper');

    if (foucWrapper) {
      foucWrapper.style.opacity = '1';
    }
  }, []);

  return (
    <div id="fouc-wrapper" style={{ opacity: 0 }}>
      {children}
    </div>
  );
};

export default FoucWrapper;
